import { BackgroundColor } from './background-color.js'

export * from './background-color.js'

export default BackgroundColor
